import FlexContainer from "@/components/FlexContainer";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { useAppSelector } from "@/hooks/redux";
import {
    InfoContainerList,
    InfoContainerListCenterBlock,
    InfoContainerListTopBlock,
    UserInfo,
    UserInfoDescriptionText,
    UserInfoTitle,
} from "@/pages/Profile/Account/Styled";

function Account() {
    const { firstName, lastName, phone, email } = useAppSelector(
        (state) => state.user,
    );

    return (
        <>
            <Meta title="Profile" />
            <Header title="Керування даними акаунта" path="/profile" />
            <MainContainer>
                <UserInfo>
                    <UserInfoTitle>Особисті дані</UserInfoTitle>
                    <InfoContainerList>
                        <InfoContainerListTopBlock>
                            <FlexContainer
                                flexDirection="column"
                                alignItems="flex-start"
                                gap="12px"
                            >
                                <UserInfoTitle>ПІБ</UserInfoTitle>
                                <UserInfoDescriptionText>
                                    {firstName} {lastName}
                                </UserInfoDescriptionText>
                            </FlexContainer>
                        </InfoContainerListTopBlock>
                        <InfoContainerListCenterBlock>
                            <FlexContainer
                                flexDirection="column"
                                alignItems="flex-start"
                                gap="12px"
                            >
                                <UserInfoTitle>E-mail</UserInfoTitle>
                                <UserInfoDescriptionText>
                                    {email}
                                </UserInfoDescriptionText>
                            </FlexContainer>
                        </InfoContainerListCenterBlock>
                        <InfoContainerListCenterBlock
                        // onClick={() => navigate("/profile/change-phone")}
                        >
                            <FlexContainer
                                flexDirection="column"
                                alignItems="flex-start"
                                gap="12px"
                            >
                                <UserInfoTitle>Номер телефону</UserInfoTitle>
                                <UserInfoDescriptionText>
                                    {phone}
                                </UserInfoDescriptionText>
                            </FlexContainer>
                            {/*<RightOutlined*/}
                            {/*    style={{*/}
                            {/*        width: "16px",*/}
                            {/*        height: "16px",*/}
                            {/*        fontSize: "16px",*/}
                            {/*    }}*/}
                            {/*/>*/}
                        </InfoContainerListCenterBlock>
                    </InfoContainerList>
                </UserInfo>
            </MainContainer>
        </>
    );
}

export default Account;
